import { Link, useLocation, useNavigate } from "react-router-dom"
import { useRef, useState } from "react";
import { handleError, useAuth } from "../../modules/authentication/AuthProvider";
import { Input, Button, Alert } from "react-daisyui";
import routes from "../../modules/routes/Routes";
import { AuthError } from "@supabase/supabase-js";
import AuthenticationScreen from "./AuthenticationScreen";
import { useTranslation } from 'react-i18next';

const Login: React.FC = () => {
    const { login } = useAuth();
    const { t } = useTranslation();

    const emailRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);

    const [emailError, setEmailError] = useState<string | null>(null);
    const [passwordError, setPasswordError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const navigate = useNavigate();
    const location = useLocation();

    async function handleAuthError(error: AuthError) {
        const handledError = handleError(error);

        console.log({ error, authError: handledError })

        if (handledError) {
            handledError.field === 'password'
                ? setPasswordError(handledError.message)
                : setEmailError(handledError.message);
        }
    }

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        setEmailError(null);
        setPasswordError(null);

        if (emailRef.current && passwordRef.current) {
            setLoading(true);

            const credential = await login(emailRef.current.value, passwordRef.current.value);

            if (credential.error !== null)
                handleAuthError(credential.error)
            else
                navigate(routes.app.matches.build());
        }
        setLoading(false);
    }

    return (
        <AuthenticationScreen title={t('authentication.login.title')}>
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <div className="flex flex-col gap-3">
                    {location.hash === '#confirmEmail' && (
                        <Alert color="info">
                            {t('authentication.login.confirmEmailMessage')}
                        </Alert>
                    )}
                    <Input 
                        ref={emailRef} 
                        type="email" 
                        placeholder={t('authentication.login.emailPlaceholder')}
                        color={emailError !== null ? "error" : undefined} 
                        data-testid="login-email"
                        required 
                    />
                    <Input 
                        ref={passwordRef} 
                        type="password" 
                        placeholder={t('authentication.login.passwordPlaceholder')}
                        color={passwordError !== null ? "error" : undefined} 
                        data-testid="login-password"
                        required 
                    />
                    <Button type="submit" color="primary" disabled={loading} data-testid="login-submit">
                        {loading ? t('authentication.login.loggingIn') : t('authentication.login.loginButton')}
                    </Button>

                    {(emailError !== null || passwordError !== null) && (
                        <Alert color="error" data-testid="login-error">
                            {emailError ?? passwordError}
                        </Alert>
                    )}

                    <p className="mt-3 text-sm">
                        {t('authentication.login.newHere')} <Link to={routes.authentication.registration.build()} className="text-primary">{t('authentication.login.registerNow')}</Link>
                    </p>
                </div>
            </form>
        </AuthenticationScreen>
    );
}

export default Login;
